// Плотность таблиц (ux.md «Табеля», раздел 6): «Обычная» — строка size-row-list, «Компактная» —
// size-row. Выбор — в настройках вида на этом устройстве; таблица, у которой плотность задана
// явно (плотная таблица журнала), её не меняет.
import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

export type TableDensity = 'list' | 'dense';

const TableDensityContext = createContext<TableDensity>('list');

export function TableDensityProvider({
  density,
  children,
}: {
  density: TableDensity;
  children: ReactNode;
}) {
  return <TableDensityContext value={density}>{children}</TableDensityContext>;
}

/** Плотность таблиц по умолчанию — из настроек вида. */
export function useTableDensity(): TableDensity {
  return useContext(TableDensityContext);
}
